import { styled } from '@mui/material';

import { Alert, Skeleton } from '@app-velocity/ui';

import { useI18n } from '@app-velocity/i18n';

import { useGetInvoicesQuery } from '../../queries/useGetInvoicesQuery';
import { SingleInvoice } from './components/SingleInvoice';

const InvoicesList = styled('ul')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  listStyleType: 'none',
  padding: 0,
  margin: 0,
}));

export const Billing = () => {
  const { data: invoicesData, isLoading } = useGetInvoicesQuery();
  const { t } = useI18n();

  if (isLoading) return <Skeleton height={50} />;

  if (
    !invoicesData ||
    !invoicesData.invoices ||
    invoicesData.invoices.length === 0
  )
    return <Alert severity="info">{t('payments:no_invoices')}</Alert>;

  const { invoices } = invoicesData;

  return (
    <InvoicesList>
      {invoices.map((invoice) => (
        <SingleInvoice key={invoice.id} invoice={invoice} />
      ))}
    </InvoicesList>
  );
};
